'use client'

import { HTMLProps, useLayoutEffect, useRef, useState } from 'react'
import clsx from 'classnames'
import style from './article-navigation.module.scss'

interface ArticleNavigationProps extends HTMLProps<HTMLDivElement> {
  additionalSelector?: string
}

export const ArticleNavigation = (props: ArticleNavigationProps) => {
  const { className, additionalSelector = ', article h3' } = props
  const titleMapRef = useRef<Record<string, Element>>({})
  const [items, setItems] = useState<string[]>([])

  const findItems = () => {
    const titleEls = Array.from(document.querySelectorAll('article h1, article h2' + additionalSelector))

    const items = titleEls.map(titleEl => {
      const label = titleEl.textContent ?? ''
      const encodeTitle = encodeURI(label)
      titleEl.id = encodeTitle

      titleMapRef.current[encodeTitle] = titleEl

      return label
    })

    setItems(items)
  }

  useLayoutEffect(findItems, [])

  return (
    <ul className={clsx(style.container, className)}>
      {items.map(id => (
        <button
          className={clsx(style.item, 'text text_type_t2', { [style.active]: false })}
          key={id}
          onClick={() => {
            const encodeTitle = encodeURI(id)
            const element = titleMapRef.current[encodeTitle]

            if (element) {
              element.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
              })
            }

            findItems()
          }}
        >
          {id}
        </button>
      ))}
    </ul>
  )
}
